(function () {
  function formatMoney(cents) {
    return '$' + (Number(cents) / 100).toFixed(2) + ' USD';
  }

  function getItemCount(label) {
    const l = (label || '').toLowerCase();
    if (l.indexOf('8') !== -1) return 8;
    if (l.indexOf('4') !== -1) return 4;
    if (l.indexOf('2') !== -1) return 2;
    return 1;
  }

  function updatePrice(card, radio) {
    if (!card || !radio) return;

    const priceList = card.querySelector('price-list');
    if (!priceList) return;

    const salePriceEl = priceList.querySelector('sale-price');
    let comparePriceEl = priceList.querySelector('compare-at-price');
    const unitPriceEl = priceList.querySelector('unit-price');

    const price = Number(radio.dataset.price || 0);
    const compare = Number(radio.dataset.compare || 0);
    const itemCount = getItemCount(radio.dataset.packLabel || '');

    if (salePriceEl) {
      salePriceEl.textContent = formatMoney(price);

      if (compare > price) {
        salePriceEl.classList.remove('text-subdued');
        salePriceEl.classList.add('text-on-sale');
      } else {
        salePriceEl.classList.remove('text-on-sale');
        salePriceEl.classList.add('text-subdued');
      }
    }

    if (compare > price) {
      if (!comparePriceEl) {
        comparePriceEl = document.createElement('compare-at-price');
        comparePriceEl.className = 'h6 text-subdued line-through';
        priceList.appendChild(comparePriceEl);
      }

      comparePriceEl.textContent = formatMoney(compare);
      comparePriceEl.style.display = '';
    } else if (comparePriceEl) {
      comparePriceEl.textContent = '';
      comparePriceEl.style.display = 'none';
    }

    if (unitPriceEl) {
      const perItem = itemCount > 0 ? price / itemCount : price;
      unitPriceEl.textContent = '($' + (perItem / 100).toFixed(2) + '/item)';
    }
  }

  function updateVariant(root, radio) {
    if (!root || !radio) return;

    const form = root.querySelector('form');
    const variantInput = root.querySelector('[data-variant-id]');
    const card = root.closest('.product-card');

    if (!form || !variantInput || !card) return;

    variantInput.value = radio.dataset.variantId;

    form.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.value = radio.dataset.variantId;
    });

    updatePrice(card, radio);
  }

  function initPackRoot(root) {
    if (!root || root.dataset.gjInitialized === 'true') return;

    const form = root.querySelector('form');
    const radios = root.querySelectorAll('.gj-pack-radio');
    const card = root.closest('.product-card');

    if (!form || !radios.length || !card) return;

    root.dataset.gjInitialized = 'true';

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        updateVariant(root, radio);
      });

      radio.addEventListener('click', function () {
        updateVariant(root, radio);
      });
    });

    form.addEventListener('submit', function () {
      const checked = root.querySelector('.gj-pack-radio:checked');
      if (checked) {
        updateVariant(root, checked);
      }
    });

    const checked = root.querySelector('.gj-pack-radio:checked') || radios[0];
    if (checked) {
      checked.checked = true;
      updateVariant(root, checked);
    }
  }

  function initAllPackRoots(scope) {
    const rootNode = scope || document;
    rootNode.querySelectorAll('[data-pack-root]').forEach(function (root) {
      initPackRoot(root);
    });
  }

  function boot() {
    initAllPackRoots(document);

    document.addEventListener('shopify:section:load', function (event) {
      initAllPackRoots(event.target);
    });

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!(node instanceof HTMLElement)) return;

          if (node.matches && node.matches('[data-pack-root]')) {
            initPackRoot(node);
          } else if (node.querySelectorAll) {
            initAllPackRoots(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();